import { Component, OnInit, Output } from '@angular/core';
import { Personorg } from './model/personorg';
import { PersonorglistService } from './service/personorglist.service';
import { Router } from '@angular/router';
import { Organization } from './model/Organization';
import { Person } from './model/person';
import { SessionHelper } from '@src/app/helpers/sessionHelper';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-personorglist',
  templateUrl: './personorglist.component.html',
  styleUrls: ['./personorglist.component.css']
})
export class PersonorglistComponent implements OnInit {
  @Output() PersonorgList:Personorg[];
  PersonId:string = SessionHelper.getUserSub();
  @Output() orgDetail:Organization;
  @Output() showSpinner:boolean;
  modalPersonorg:Personorg;
  leaver:boolean;

  constructor(
    private personorgsrv: PersonorglistService,
    private router:Router
    ) { }

  ngOnInit() {
    this.leaver = false;
    this.showSpinner = true;
    this.PersonorgList = [];
    this.modalPersonorg = new Personorg;
    this.orgDetail = new Organization;
    
    this.personorgsrv.getPersonOrgs(this.PersonId).pipe(untilDestroyed(this)).subscribe(list =>{
      this.PersonorgList =list;
      this.showSpinner = false;
    });
  }
  addOrg(){
    this.router.navigate(['/joinorg']);
  }
  leaverF(){
    this.leaver = !this.leaver;
  }
  leaveOrg(){
    this.modalPersonorg.date_left = new Date();
    this.modalPersonorg.relationtype = "left";
    this.personorgsrv.leaveOrg(this.modalPersonorg).pipe(untilDestroyed(this)).subscribe(resp => {
    });
  }

  reJoin(){
    this.modalPersonorg.date_left = null;
    this.modalPersonorg.date_requested = new Date();
    this.modalPersonorg.relationtype = "Joiner";
    this.modalPersonorg.member_function = "Not assigned yet";
    this.personorgsrv.requestRejoin(this.modalPersonorg).pipe(untilDestroyed(this)).subscribe(resp => {

    });
  }
  getOrgDetail(showorg:Personorg){
    this.modalPersonorg = showorg;
    this.personorgsrv.getOrgDetails(showorg).pipe(untilDestroyed(this)).subscribe(resp => {
      this.orgDetail = resp;
    });
  }
  cleanup(){
    this.modalPersonorg = new Personorg;
  }
  inOrg(){
    if(this.modalPersonorg.relationtype == "left"){
      return false;
    }else{
      return true;
    }
    
  }
  showList(){
    if(SessionHelper.getCustomer()){
      return false;
    }else{
      return true;
    }
  }

}
